import React from 'react';
import { C } from '../constants';

/**
 * Política de tratamiento de datos — Ley 1581/2012.
 * Pública: se monta FUERA del shell (solar-hub.co/privacidad).
 * FluxAI es la misma empresa (Alebas), no un tercero ajeno.
 */
export default function Privacidad() {
  return (
    <div style={{ minHeight: '100vh', background: C.dark, color: C.text }}>
      <header style={{
        position: 'sticky', top: 0, zIndex: 10, height: 48, padding: '0 20px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        borderBottom: `1px solid ${C.border}`,
        background: `linear-gradient(180deg, ${C.nav} 0%, ${C.nav2} 100%)`,
      }}>
        <a href="/" style={{ display: 'flex', alignItems: 'baseline', gap: 1, textDecoration: 'none' }}>
          <span style={{ fontWeight: 900, fontSize: 18, color: C.heading }}>Solar</span>
          <span style={{ fontWeight: 900, fontSize: 18, color: C.yellow }}>Hub</span>
        </a>
        <a href="/" style={{ fontSize: 12, color: C.teal, fontWeight: 700, textDecoration: 'none' }}>Volver a Solar Hub</a>
      </header>

      <main style={{ maxWidth: 720, margin: '0 auto', padding: '28px 20px 64px', lineHeight: 1.6, fontSize: 14 }}>
        <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1.2, textTransform: 'uppercase', color: C.teal, margin: 0 }}>Ley 1581 de 2012</p>
        <h1 style={{ margin: '6px 0 8px', fontSize: 26, fontWeight: 900, color: C.heading, letterSpacing: '-0.4px' }}>
          Política de tratamiento de datos personales
        </h1>
        <p style={{ margin: '0 0 22px', fontSize: 13, color: C.muted }}>
          Solar Hub es un producto de <strong style={{ color: C.heading }}>ALEBAS Ingeniería S.A.S.</strong> (NIT 901.992.450-5).
          Responsable del tratamiento: la misma sociedad. Contacto:{' '}
          <a href="mailto:ing@alebas.co" style={{ color: C.teal }}>ing@alebas.co</a>
          {' · '}
          <a href="mailto:info@alebas.co" style={{ color: C.teal }}>info@alebas.co</a>.
        </p>

        {/* Decreto 1377 de 2013, art. 13 (hoy DUR 1074 de 2015): la política tiene que decir quién es
            el responsable con su domicilio, dirección, correo y teléfono; el tratamiento y sus
            finalidades; los derechos; quién atiende; el procedimiento; y la vigencia. */}
        <H>Responsable del tratamiento</H>
        <p>
          ALEBAS INGENIERÍA S.A.S. (Consultoría e Ingeniería en Eficiencia Energética S.A.S.), NIT 901.992.450-5.
          Domicilio: Villavicencio (Meta). Dirección: CR 36 24 A 44 Oficina 2, Villavicencio. Correo:{' '}
          <a href="mailto:info@solar-hub.co" style={{ color: C.teal }}>info@solar-hub.co</a>. Teléfono y WhatsApp: +57 316 308 5286.
        </p>

        <H>Qué datos tratamos</H>
        <p>
          Los que usted entrega al cotizar, inscribirse o contratar: nombre, correo, teléfono,
          dirección del predio, operador de red, consumo o perfil de carga, y los datos técnicos
          del sistema (kWp, equipos). Si hay sesión de la suite, el identificador de usuario.
          Si hay telemetría, lecturas de energía asociadas al medidor asignado.
        </p>

        <H>Para qué</H>
        <ul style={ul}>
          <li>Elaborar y enviar cotizaciones y el estudio fotovoltaico.</li>
          <li>Coordinar instalación, técnicos y proveedores.</li>
          <li>Facturar hardware (Solar Hub) y el servicio AMI (FluxAI), cuando corresponda.</li>
          <li>Soporte (chat, correo, WhatsApp de la línea Alebas) y <a href="https://alebas.co/?linea=solarhub#radicar" style={{ color: C.teal }}>PQR unificada</a>.</li>
          <li>Monitoreo de planta: Solar Hub <em>pide</em> equipos y ficha a FluxAI; no abre la consola AMI.</li>
          <li>Técnicos e instaladores de la red: verificar su identidad y su título o matrícula, habilitar y auditar su operación, pagarles, cobrarles, debitar lo que autorizaron y facturar.</li>
        </ul>

        <H>Datos sensibles: la selfie de los técnicos</H>
        <p>
          Para habilitar a un técnico, ALEBAS compara una <strong style={{ color: C.heading }}>selfie</strong> con la
          foto de su documento y consulta su matrícula en el COPNIA, por medio de su encargado{' '}
          <strong style={{ color: C.heading }}>Verifik</strong>. La imagen del rostro es un dato biométrico y por eso
          sensible (Ley 1581, arts. 5 y 6): se pide con autorización previa, expresa e informada, y{' '}
          <strong style={{ color: C.heading }}>el titular no está obligado a darla</strong>. Quien prefiera no usar
          biometría puede pedir la revisión a distancia escribiendo a info@solar-hub.co. No pedimos datos
          sensibles a los clientes que cotizan.
        </p>

        <H>Quién más los ve (misma empresa)</H>
        <p>
          <strong style={{ color: C.heading }}>FluxAI</strong> (fluxai.solutions) es la plataforma AMI de Alebas,
          no un comprador de bases. Recibe los datos necesarios para identidad, equipos asignados y
          telemetría. No se venden a terceros. Encargados de cómputo: Railway y Vercel, bajo contrato
          con Alebas. El canal de WhatsApp usa el proveedor de la línea Alebas (Kapso), solo para
          mensajes que usted inicia o que el soporte le envía.
        </p>
        <p>
          Otros encargados, con contrato de transmisión (DUR 1074 de 2015): <strong style={{ color: C.heading }}>Verifik</strong>{' '}
          (verificación de identidad y consulta del COPNIA de los técnicos), <strong style={{ color: C.heading }}>Wompi</strong>{' '}
          (pagos) y el proveedor de facturación electrónica (Siigo). Algunos pueden alojar datos fuera de
          Colombia, con un nivel de protección adecuado.
        </p>

        <H>Sus derechos (Habeas Data)</H>
        <p>
          Puede conocer, actualizar, rectificar y suprimir sus datos, y revocar la autorización,
          escribiendo a <a href="mailto:ing@alebas.co" style={{ color: C.teal }}>ing@alebas.co</a> con
          asunto «datos personales». Responderemos en los plazos de la Ley 1581. La cotización y
          el estudio no se pueden emitir sin los datos de contacto: si los suprime, el trámite queda cerrado.
        </p>
        <p>
          También puede pedir prueba de la autorización que nos dio, saber qué uso les hemos dado a sus
          datos, consultarlos gratis y presentar quejas ante la Superintendencia de Industria y Comercio
          (Ley 1581, art. 8).
        </p>

        <H>Quién atiende y cómo se tramita</H>
        <ul style={ul}>
          <li><strong style={{ color: C.heading }}>Área responsable:</strong> Atención de datos personales de ALEBAS, en{' '}
            <a href="mailto:info@solar-hub.co" style={{ color: C.teal }}>info@solar-hub.co</a> o{' '}
            <a href="mailto:ing@alebas.co" style={{ color: C.teal }}>ing@alebas.co</a>.</li>
          <li><strong style={{ color: C.heading }}>Consultas</strong> (qué datos suyos tenemos): se responden en máximo{' '}
            <strong style={{ color: C.heading }}>diez (10) días hábiles</strong>; si no alcanza, le avisamos el motivo y
            respondemos en máximo cinco (5) días hábiles más (Ley 1581, art. 14).</li>
          <li><strong style={{ color: C.heading }}>Reclamos</strong> (corregir, actualizar, suprimir o revocar): se responden en máximo{' '}
            <strong style={{ color: C.heading }}>quince (15) días hábiles</strong>, prorrogables por ocho (8) días hábiles más
            avisándole el motivo (art. 15). El reclamo debe traer su identificación, la descripción de los
            hechos, su dirección y los documentos que quiera hacer valer; si llega incompleto, le pedimos
            completarlo dentro de los cinco (5) días siguientes, y si pasan dos (2) meses sin respuesta se
            entiende que desistió.</li>
          <li>Antes de acudir a la Superintendencia de Industria y Comercio debe agotar este trámite con nosotros (art. 16).</li>
        </ul>

        <H>Conservación</H>
        <p>
          Mientras la cotización, el contrato o la telemetría estén activos, y el tiempo que exijan
          facturación y normas colombianas (entre ellas CREG y RETIE cuando apliquen). Después se
          baja o se anonimiza.
        </p>

        <H>Vigencia</H>
        <p>
          Esta versión de la política rige desde el 7 de octubre de 2026. Las bases de datos se conservan
          mientras duren las finalidades descritas y los plazos que exige la ley. Si la política cambia,
          publicamos la nueva versión en esta página y, si el cambio afecta la finalidad, le pedimos una
          nueva autorización.
        </p>

        <p style={{ marginTop: 28, fontSize: 12, color: C.muted }}>
          Esta página publica la política. No sustituye el registro de bases ante la SIC, que es
          un trámite de Alebas aparte. Ver también los{' '}
          <a href="/terminos" style={{ color: C.teal }}>Términos y condiciones</a>.
        </p>
      </main>
    </div>
  );
}

function H({ children }) {
  return (
    <h2 style={{ margin: '22px 0 8px', fontSize: 15, fontWeight: 800, color: C.heading }}>{children}</h2>
  );
}
const ul = { margin: '0 0 12px', paddingLeft: 18, color: C.text };
